export default __webpack_public_path__ + "static/media/shipping-time.aa282724.svg";